import { render, staticRenderFns } from "./heim-icon-button.vue?vue&type=template&id=2b5889a1&scoped=true&"
import script from "./heim-icon-button.vue?vue&type=script&lang=js&"
export * from "./heim-icon-button.vue?vue&type=script&lang=js&"
import style0 from "./heim-icon-button.vue?vue&type=style&index=0&id=2b5889a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5889a1",
  null
  
)

component.options.__file = "heim-icon-button.vue"
export default component.exports